<template>
  <regular-tables-template
    :headers="headersT"
    :datas="data"
    :title="$t(title)"
    :is-loading="isLoading"
    :has-error="hasError"
    :error-msg="errorMsg"
    :error-empty="errorEmpty"
    :color="color"
    icon="mdi-help"
  />
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import RegularTablesTemplate from './templates/RegularTablesTemplate.vue'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'QuestionMoment',

    /* Sous-composants utilisés par ce composant */
    components: {
      RegularTablesTemplate,
    },

    /* Paramètres */
    props: {
      request: {
        type: String,
        default: '',
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
      errorMsg: {
        type: String,
        default: 'Erreur',
      },
      errorEmpty: {
        type: Object,
        default: function () {
          return {
            msg: 'Un problème est survenu.',
            icon: 'mdi-alert-rhombus-outline',
            color: 'error',
          }
        },
      },
      color: {
        type: String,
        default: 'primary',
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        title: 'Measure.QuestionOfTheMoment',
        headers: [
          'Measure.Table.Headers.Title',
          'Measure.Table.Headers.Score',
          'Measure.Table.Headers.NumberOfAnswers',
          'Measure.Table.Headers.Thematic',
        ],
        data: [],
        isLoading: true,
        hasError: false,
      }
    },

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      // Traduction des headers
      headersT: function () {
        return this.headers.map(header => {
          return this.$t(header)
        })
      },
    },

    /* Variables surveillées : traitement si modification de sa valeur */
    watch: {
      request: function (newVal, oldVal) {
        this.fetchQuestionMoment()
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.fetchQuestionMoment()
    },

    /* Fonctions internes */
    methods: {
      // Récupération des données statistiques
      fetchQuestionMoment: function () {
        this.isLoading = true
        this.$Auth.httpRequest(
          'get',
          'api/dashboard/questionOfTheMoment' + this.request,
        )
          .then(response => {
            if (
              !Array.isArray(response.data) ||
              (Array.isArray(response.data) && response.data.length < 1)
            ) {
              this.data = []
            } else {
              this.data = response.data
            }
            this.hasError = false
          })
          .catch((error) => {
            this.hasError = true
            if (this.isAdmin) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
            this.$emit('set-error', error)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
    },
  }
</script>
